// @ts-nocheck

import React, { lazy, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import styled, { css } from 'styled-components';

import GlobalStyleGrid from '../../modules/grids/components/GlobalStyleGrid';
import { RoutePatterns } from '../../types/routes';
import WinaLoader from '../WinaLoader';

type Props = {
  isGridHistory: boolean;
};

const GridsRouteContainer = lazy(() => import('../../modules/grids/containers/routes/GridsRouteContainer'));
const GridsHistoryDetailRouteContainer = lazy(
  () => import('../../modules/grids/containers/routes/GridsHistoryDetailRouteContainer'),
);
const GridsShareRouteContainer = lazy(() => import('../../modules/grids/containers/routes/GridsShareRouteContainer'));
const GridsHistoryRouteContainer = lazy(
  () => import('../../modules/grids/containers/routes/GridsHistoryRouteContainer'),
);
const GridsPublicRouteContainer = lazy(() => import('../../modules/grids/containers/routes/GridsPublicRouteContainer'));

const MiddleColumnWrapper = styled.div`
  z-index: 12;

  ${({ $isGridHistory, theme }) =>
    $isGridHistory
      ? css`
          padding-left: 10px;
          width: 740px;
        `
      : css`
          padding: 0 10px;
          width: 350px;

          @media screen and (min-width: ${theme.breakpoints.md}px) {
            width: 500px;
          }
        `}
`;

/**
 * Display the middle column for the grids section
 *
 * @param  {boolean} isGridHistory Check if we are on grid history (the history detail is excluded)
 * @return {ReactNode}             A styled component with all the necessary routes
 */
const DesktopGridsLayoutMiddleColumn = ({ isGridHistory }: Props) => {
  return (
    <MiddleColumnWrapper $isGridHistory={isGridHistory}>
      <Suspense fallback={<WinaLoader />}>
        <GlobalStyleGrid>
          <Switch>
            <Route path={RoutePatterns.GRID_PUBLIC} exact>
              <GridsPublicRouteContainer />
            </Route>
            <Route path={RoutePatterns.GRID_HISTORY_DETAIL} exact>
              <GridsHistoryDetailRouteContainer />
            </Route>
            <Route path={RoutePatterns.GRID_HISTORY} exact>
              <GridsHistoryRouteContainer />
            </Route>
            <Route path={RoutePatterns.GRID_SHARE} exact>
              <GridsShareRouteContainer />
            </Route>
            <Route path={RoutePatterns.POOL} exact>
              <GridsRouteContainer />
            </Route>
          </Switch>
        </GlobalStyleGrid>
      </Suspense>
    </MiddleColumnWrapper>
  );
};

export default DesktopGridsLayoutMiddleColumn;
